import { toast } from "react-toastify";

export const displaySuccess = (text: string) =>
  toast.success(text, {
    position: "bottom-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const displayError = (error: string) =>
  toast.error(error, {
    position: "bottom-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    style: {
      whiteSpace: "pre-line",
    },
  });

export const displayWarning = (error: string) =>
  toast.warning(error, {
    position: "bottom-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    style: {
      whiteSpace: "pre-line",
    },
  });

export const clearAll = () => toast.dismiss();
